export default "__VITE_ASSET__DetBdkdP__"